const fetchLatestPhoto = async ({s3, folderId, bucketName}) => {
    try {
        const params = {
            Bucket: bucketName,
            Prefix: `${folderId}/`
        };
        const data = await s3.listObjectsV2(params).promise();
        const sorted = data.Contents.sort((a, b) => b.LastModified - a.LastModified);
        if (sorted.length > 0) {
            const latestKey = sorted[0].Key;
            return s3.getSignedUrl("getObject", {
                Bucket: params.Bucket,
                Key: latestKey,
                Expires: 60 * 10 // URL valable 10 minutes
            });
        }
    } catch (err) {
        console.error("Error fetching latest photo:", err);
    }
    return null
};

const uploadPhoto = async ({s3, folderId, bucketName, file, onSuccess, onError}) => {
    const fileName = `${folderId}/${Date.now()}-${file.name}`;

    const params = {
        Bucket: bucketName,
        Key: fileName,
        Body: file,
        ContentType: file.type
    };

    try {
        await s3.upload(params).promise();
        onSuccess(null, file);
        return s3.getSignedUrl("getObject", {
            Bucket: params.Bucket,
            Key: fileName,
            Expires: 60 * 10 // URL valable 10 minutes
        });
    } catch (err) {
        console.error("Upload failed:", err);
        onError(err);
    }
    return null;
}

export {
    fetchLatestPhoto,
    uploadPhoto,
}